export const JET_KEY = "jet";
export const CLOUD_KEY = "cloud";
export const BULLET_KEY = "bullet";
export const EXPLOSION_KEY = "explosion";
